<template lang="pug">
  DefaultLayout
    CommonSection(title="Правила партнерской программы")
      .b-affiliate-rules-page
        ._tabs
          AffiliateTabs
        FormBlock(mobile)._main
          ._rules
            p Данные правила являются частью <a href="https://teroom.ru/agreement/">Лицензионного соглашения</a> и подписанных в письменном виде договоров с ООО "Лидер" (далее - Общество). Данные правила принимаются всеми клиентами Общества в момент регистрации на сайте Общества и акцепта Лицензионного соглашения Общества. Одновременно с этим клиенту Общества также присваивается статус Партнера и персональный идентификатор партнера (ПИП).
            h2 Термины и определения
            ol
              li Партнёрская Программа — форма сотрудничества, позволяющая получать вознаграждение за привлечение новых Пользователей в Сервис.
              li Партнёр — Пользователь, участвующий в Партнёрской Программе.
              li Реферал — Пользователь, зарегистрировавшийся в Сервисе после перехода по Реферальной Ссылке Партнёра.
              li Реферальная Ссылка — ссылка на любую страницу Сервиса с аргументом affiliate=ПИП.
            h2 1. Порядок учёта клиентов и расчётов
            p 1.1. За привлечение Клиентов по Партнерской программе Партнеру на аккаунт начисляются бонусные средства, которые Партнер может использовать в качестве скидки на услуги Общества. Указанную скидку Партнер может использовать на своем аккаунте, либо может передать третьим лицам, имеющим зарегистрированный аккаунт в системе Общества.
            p 1.2. Для уже зарегистрированного Клиента ПИП в анкете Клиента не проставляется и начисления бонусных средств с оплат данного Клиента Партнеру не производятся.
            p 1.3. Начисления бонусных средств производятся автоматически после оплаты услуг Общества привлеченным Клиентом. Начисления бонусных средств производятся с учетом ограничений, установленных настоящими Правилами.
            p 1.4. Начисление бонусных средств происходят только на активном (не заблокированном) аккаунте Партнера, т.е. только в том случае, если Партнер пользуется в момент начислений услугами Общества. При удалении аккаунта Партнера, все бонусные средства и привлеченные Клиенты — аннулируются и восстановлению не подлежат.
            p 1.5. По усмотрению Общества, начисление бонусных средств может проходить ручную проверку. Срок проверки — до 3 месяцев.
            p 1.6. Размер начисляемых бонусных средств определяется путем сложения начислений с каждой оплаты произведенной Клиентом, в соответствии с п. 2 настоящих Правил.
            p 1.7. Все случаи нарушения данных правил тщательно анализируются, и если нарушение подтверждается, то Партнеру выносится предупреждение, а начисления и привлеченные Партнером Клиенты с нарушениями Правил аннулируются. Если случай нарушения правил повторяется, Общество запрещает Партнеру участвовать в Партнерской программе - все бонусные средства и привлеченные Партнером Клиенты аннулируются.
            p 1.8. Партнерам запрещается:
            ul
              li Производить принудительную переадресацию пользователей на сайт(-ы) Общества через рекламную ссылку или баннер.
              li Производить рекламную рассылку (спам) с указанием рекламной информации Общества или сайта Общества.
              li Использование и распространение информации об Обществе на веб-ресурсах, которые нарушают действующее законодательство Российской Федерации.
              li Размещать рекламные материалы на ресурсах, где уже присутствует хотя бы одна гиперссылка на сайт Общества без содержания какого-либо ПИП, без предварительного согласования с Обществом.
              li Привлекать Клиентов с полной или частичной компенсацией стоимости услуг хостинга приглашенным Клиентам, без предварительного согласования с Обществом.
              li Предоставлять потенциальным Клиентам информацию о стоимости услуг, которая отличается от указанной на сайте Общества https://teroom.ru или иную информацию об Обществе и его услугах, которая не соответствует действительности.
              li Регистрировать аккаунты для личного использования через свою партнёрскую программу. В частности аккаунты Партнера и Клиента не могут быть зарегистрированы на одно и то же лицо, и/или на один и тот же e-mail или номер телефона.
              li Вводить пользователей в заблуждение, выдавая свои сайты и/или страницы в социальных сетях за официальный сайт и/или страницы Общества.
            p 1.9. В случае, если рекомендации Партнером услуг Общества, будут попадать под определение рекламы, при размещении рекламных материалов, Партнер обязуется своевременно получать от оператора рекламных данных (ОРД) идентификатор рекламы, оплачивая при необходимости услуги ОРД, указывать полученный идентификатор рекламы во всех рекламных материалах, добавлять пометку «реклама», а также указание на сайт Общества, передавать за Общество всю необходимую информацию о распространяемой рекламе в Единый реестр интернет-рекламы (ЕРИР) через ОРД в порядке и сроки, установленные законодательством РФ.
            p 1.10. Общество, в любой момент, в одностороннем порядке, имеет право изменять условия партнерской программы и настоящие Правила, а также приостановить либо полностью отменить партнерскую программу и аннулировать начисленные бонусные средства.
            p 1.11. Уведомления, направленные Обществом на контактный адрес электронной почты Партнера, имеют юридическую силу документа, исполненного в простой письменной форме.
            h2 2. Размер начислений
            p 2.1. С каждой оплаты Клиента, привлеченного Партнером в соответствии с настоящими Правилами, поступившей на счет Общества, Партнеру производится начисление бонусных средств в 30% от суммы платежа.
            p 2.2. Общество вправе изменить размер и порядок начисления бонусных средств в период проведения промо-акций, либо же полностью отменить начисление таких бонусных средств.
            p 2.4. В случае возврата оплаты Клиентом сумма начисленных Партнеру бонусных средств подлежит пересчету.
        FormBlock(mobile)._aside
          ._aside-title Ваши данные
          UiKeyVal._aside-info-highlight(:items="info1")
          UiKeyVal(:items="info2")
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import FormBlock from '@/components/FormBlock.vue';
import AffiliateTabs from '@/components/affiliate/AffiliateTabs.vue';
import ChartBar from '@/components/chart/ChartBar.vue';
import UiKeyVal from '@/components/ui/UiKeyVal.vue';
import utils from '@/utils/common';

export default {
  name: 'AffiliateRulesPage',
  components: {
    UiKeyVal,
    ChartBar,
    AffiliateTabs,
    FormBlock,
    DefaultLayout,
    CommonSection,
  },
  created() {
    this.$store.dispatch('affiliate/fetch');
    this.$store.dispatch('payout/fetch');
  },
  computed: {
    user() { return this.$store.state.auth.user; },
    balance() { return this.user.affiliateBalance / 100; },

    referrals() { return this.$store.getters['affiliate/referrals']; },
    referralsOptions() { return this.referrals.map(r => ({ value: r['@id'], user: r })); },
    payouts() { return (this.$store.state.payout.items ?? []).map(p => ({ ...p, createdAt: new Date(p.createdAt) })); },
    payoutsSum() { return this.payouts.reduce((acc, val) => val.amount + acc, 0); },
    lastPayout() { return this.last(this.payouts); },
    lastPayoutDate() { return this.lastPayout ? utils.convertDateToString(this.lastPayout.createdAt, 'numeric') : '-'; },
    transactions() { return this.$store.getters['affiliate/transactions']; },
    lastTransaction() { return this.last(this.transactions); },
    lastTransactionAmount() { return this.lastTransaction ? `${this.lastTransaction.amount / 100} ₽` : '-'; },
    lastTransactionDate() { return this.lastTransaction ? utils.convertDateToString(this.lastTransaction.createdAt, 'numeric') : '-'; },
    info1() {
      return [
        { key: 'Баланс',       val: `${this.balance} ₽` }, // eslint-disable-line
        { key: 'Сумма выплат', val: `${this.payoutsSum / 100} ₽` }, // eslint-disable-line
      ];
    },
    info2() {
      return [
        { key: 'Кол-во рефералов',        val: this.referrals.length }, // eslint-disable-line
        { key: 'Активные рефералы',       val: this.referrals.filter(r => r.status === 'active').length }, // eslint-disable-line
        { key: 'Последняя выплата',       val: this.lastPayoutDate }, // eslint-disable-line
        { key: 'Последняя транзакция',    val: this.lastTransactionAmount }, // eslint-disable-line
        { key: 'Дата транзакции',         val: this.lastTransactionDate }, // eslint-disable-line
      ];
    },
  },
  methods: {
    last(list) {
      if (!Array.isArray(list) || list.length <= 0) {
        return null;
      }

      return list.reduce((acc, val) => (acc?.createdAt > val.createdAt ? acc : val));
    },
  },
};
</script>

<style scoped lang="scss">
  .affiliate-rules-page {
    display: grid;
    grid-template-columns: 1fr 312px;
    gap: 35px;
    align-items: start;

    &__tabs {
      grid-column: 1 / 2 span;
    }

    &__rules {
      background: #F5F7F9;
      border-radius: 6px;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.02em;
      color: #000000;
      padding: 24px 16px;

      p, h2 {
        margin-bottom: 10px;
      }

      ol, ul {
        padding-left: 26px;
        margin-bottom: 10px;
      }
    }

    &__aside {
      padding: 25px;

      &-title {
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        color: #232226;
      }

      &-info-highlight {
        margin: 12px 0 20px;
        padding: 24px 0 20px;
        border-top: 1px solid #EBEFF2;
        border-bottom: 1px solid #EBEFF2;

        ::v-deep .val {
          color: #33A1FB;
        }
      }
    }

    @media (max-width: 1200px) {
      grid-template-columns: 1fr;

      &__tabs {
        grid-column: 1 / 1 span;
        overflow-y: scroll;
      }
    }

    @media (max-width: 576px) {
      &__tabs {
        overflow-x: scroll;
      }
    }
  }
</style>
